import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowCurveIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        d="M6.16667 3L2 7.16667L6.16667 11.3333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7.16699H8.66667C13.2692 7.16699 17 10.8978 17 15.5003V16.3337"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

ArrowCurveIcon.displayName = 'ArrowCurveIcon';
